import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getUserFullName(user) {
  return `${user?.first_name || user?.firstName} ${user?.last_name || user?.lastName}`;
}